import React, { useState, useEffect } from 'react';
import ToolkitProvider, { CSVExport, Search  } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import Table from 'react-bootstrap/Table';
import UserEditModal from '../UserEditModal/UserEditModal';
import './UserTable.css';

export default function UserTable({ users, getUser, majorCourseBasic, majorCourseFinal }) {
  const [showUserEditModal, setShowUserEditModal] = useState(false);
  const [userChange, setUserChange] = useState();

  function handleUserEditmModalShow(user) {
    setUserChange(user);
    setShowUserEditModal(true);
  }

  const getRoleName = (role) => {
    switch (role) {
      case 'admin':
        return 'กพ.ทอ.'
      case 'adminUnit':
        return 'นขต.ทอ.'
      case 'adminUnitSpc':
        return 'หน่วย หน. สายวิทยาการ'
      case 'adminViewer':
        return 'กพ.ทอ.(ReadOnly)'
    }
  }

  return (
    <>
      <UserEditModal
        user={userChange}
        showUserEditModal={showUserEditModal}
        setShowUserEditModal={setShowUserEditModal}
        getRoleName={getRoleName}
        getUser={getUser}
        majorCourseBasic={majorCourseBasic}
        majorCourseFinal={majorCourseFinal}
      />
      <Table striped hover>
        <thead className='bgvi'>
          <tr>
            <th>#</th>
            <th>ยศ</th>
            <th>ชื่อ-นามสกุล</th>
            <th>ชื่อผู้ใช้</th>
            <th>เมลล์ ทอ.</th>
            <th>นขต.ทอ.</th>
            <th>หน่วย หน. สายวิทยาการ</th>
            <th>บทบาท</th>
          </tr>
        </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={index} 
                onClick={() => { handleUserEditmModalShow(user) }
              }>
                <td className={user?.airforceId}> {index + 1} </td>
                <td className='rank-abbrName'>{user?.rankAbbrName}</td>
                <td className='full-name'>{user?.fullName}</td>
                <td className='email'>{user?.email}</td>
                <td className='rtaf-email'>{user?.rtafEmail}</td>
                <td className='unit'>{user?.unit}</td>
                <td className='unit-spc'>{user?.unitSpcName}</td>
                <td className='role'>{getRoleName(user?.role)}</td>
              </tr>
            ))}
          </tbody>
      </Table>
    </>
  );
}